<script lang="ts" setup>
import BaseInput from '~/components/common/base-input.vue'

const model = defineModel<string>()

const keySearch = ref('')

const clearInput = () => {
  keySearch.value = ''
  model.value = ''
}

const onChangeInput = (event: Event) => {
  keySearch.value = (event.target as HTMLInputElement).value.trim()
}

watch(() => model.value, value => {
  keySearch.value = value ?? ''
})

watchDebounced(
  () => keySearch.value,
  (value: string) => model.value = value,
  { debounce: 500, immediate: true }
)
</script>

<template>
  <div class="search-form">
    <BaseInput
      :inputValue="model"
      placeholder="Tìm kiếm"
      isShowedIconDelete
      @onClearInput="clearInput"
      @input="onChangeInput"
    />
  </div>
</template>

<style lang="scss" scoped>
@import '~scssAsset/components/common/search-form.scss';
</style>
